import { Component, Injector, inject as inject_1, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn, jkRestReturnClass, jkLib, CR } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { OpenwinService, templateUrlConfigUty } from '../_service_uty';
import { Openwin } from '../_entity_uty';
import { SqlWhereComponent } from '../components/sql-where/sql-where.component';


@Component({
  selector: 'app-openwin-edit',
  templateUrl: './openwin-edit.component.html',  //templateUrlConfigUty.openwin,
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, MaterialModule],
})

export class OpenwinEditComponent extends JkDialogEditComponent<OpenwinService, Openwin> {
  override dialogRef: MatDialogRef<OpenwinEditComponent>;
  override data: jkRestReturn;
  matDialog = inject_1(MatDialog);

  override srv!: OpenwinService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<OpenwinEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }

  openMapEditor() {
    let param = { mapContent: this.item.MAP, title: "where條件設定" };
    let conf = this.initConfig_component(param);//(orm.page as BasePage)
    const dialogRef = this.matDialog.open(SqlWhereComponent, conf);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.item.MAP = result;
        if (this.cdr) {
          this.cdr.detectChanges();
        }
      }
    });
  }
  async geneItemNo() {
    this.item.ITEM = await this.srv.geneItemNo(this.item.MainTable);
    this.cdr.detectChanges();
  }
  jkShowRestError(err: any) {
    const msg = '錯誤: ' + err.error.errorLog + CR + err.message;
    alert(msg);
  }
  /*
  setDisplay() {
    //this.srv.setDisplay(this.item.SQLSelect, this.item, this.cdr);
    / *.subscribe((res: any) => {
      console.log(res.obj);
      setTimeout(() => {
        item.Display = res.obj.data;
        //alert(res.obj.data);
        // Trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
        this.cdr.detectChanges();
        document.body.style.cursor = 'default';
      }, 5);
    });* /

    this.srv.setDisplay2(this.item.SQLSelect, this.item)
      .subscribe({
        next: (res: any) => {
          Promise.resolve().then(() => {
            this.item.Display = res.obj.data;
            this.cdr.detectChanges();
          });
        },
        error: (err: any) => {
          this.jkShowRestError(err);
        }
      }

      );

  } */

}
